// Constants for the ported event dashboard.
//
// The .136 source hardcoded HOST_ID + built relative /api proxy URLs. Both are
// now per-tenant: the Universe host id is injected SERVER-SIDE from the
// tenant's universe_host_id (the client value is ignored), and all proxy URLs
// come from getApiBase() in dashboardContext. These two exports remain only to
// satisfy existing imports (HOST_ID in EventDashboard.jsx, SERVER_IP in the
// iOS ws hook).

// Placeholder — the backend overrides variables.hostId with the tenant's
// universe_host_id on every list query/subscription, so the client value is
// inert. Kept non-empty so the GraphQL variable still serializes.
export const HOST_ID = 'server-injected';

// Display/diagnostic only (used by the iOS ws hook for logging).
export const SERVER_IP = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
